<template>
  <Modal
    v-model="_value"
    width="500"
    title="修改定位设备类型"
    @on-visible-change="visibleChange"
    ok-text="确认修改"
    @on-ok="onOk"
    cancel-text="关闭">
    <Form ref="loginForm" :model="positioningDeviceType" :rules="rules">
      <FormItem prop="name">
        <label>定位设备型号：</label>
        <Input v-model="positioningDeviceType.name" placeholder="请输入定位设备型号">
        </Input>
      </FormItem>
      <FormItem prop="manufacturername">
        <label>定位设备生产商型号：</label>
        <Input v-model="positioningDeviceType.manufacturername" placeholder="请输入定位设备生产商型号">
        </Input>
      </FormItem>
      <FormItem prop="manufacturer">
        <label>设备生产商：</label>
        <Input v-model="positioningDeviceType.manufacturer" placeholder="请输入生产商">
        </Input>
      </FormItem>
      <FormItem prop="parameter">
        <label>费用模式：</label>
<!--        <Input v-model="positioningDeviceType.isfree" placeholder="请输入设备参数">-->
<!--        </Input>-->
        <Select v-model="positioningDeviceType.isfree" style="width:200px">
          <Option v-for="item in freeType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="parameter">
        <label>设备参数：</label>
        <Input type="textarea" v-model="positioningDeviceType.parameter" placeholder="请输入设备参数">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <label>设备备注：</label>
        <Input type="textarea" v-model="positioningDeviceType.remark" placeholder="请输入备注">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <!--        <label>是否ADAS：</label>-->
        <Checkbox v-model="positioningDeviceType.adas"><span>是否ADAS</span></Checkbox>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'ModifPositioningDeviceTypeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    name: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '设备类型名称不能为空', trigger: 'blur' }
        ]
      }
    },
    manufacturername: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '定位设备生产商型号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {

      freeType:[
        {label:'自费模式',value:1},
        {label:'普通免费模式',value:2},
        {label:'太好保免费模式',value:3},
      ],

      positioningDeviceType: {
        id: null,
        name: null,
        manufacturername: null,
        parameter: null,
        manufacturer: null,
        isfree: null,
        remark: null,
        adas: false
      }
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceTypeServ_ModifyObj',
      'PositioningDeviceTypeServ_GetDetail'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '确认修改设备类型',
        content: '<p>确认修改设备类型</p>',
        onOk: () => {
          store.dispatch('PositioningDeviceTypeServ_ModifyObj', {
            params: this.positioningDeviceType
          }).then(() => {
            this.$Message.success('修改成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.positioningDeviceType.id = null
        this.positioningDeviceType.name = null
        this.positioningDeviceType.manufacturername = null
        this.positioningDeviceType.parameter = null
        this.positioningDeviceType.manufacturer = null
        this.positioningDeviceType.isfree = null
        this.positioningDeviceType.remark = null
        this.positioningDeviceType.remark = null
        let positioningDeviceTypeId = this._initValue
        if (positioningDeviceTypeId) {
          store.dispatch('PositioningDeviceTypeServ_GetDetail', {
            params: { id: positioningDeviceTypeId }
          }).then(() => {
            this.positioningDeviceType = store.getters.get_PositioningDeviceType_GetDetailResult
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.name,
        manufacturername: this.manufacturername
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
